import { useEffect } from 'react';
import { Button, notification } from 'antd';
import useStore from "../store";

/**
 * 封装统一的通知方法
 * 支持 antd notification + Chrome 系统通知
 */
export const useNotification = () => {
    const {
        overview: { getMessageCount }
    } = useStore();

    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission().then(() => {
                // Permission granted
            }).catch((err) => {
                // Failed to request notification permission
            });
        }
    }, []);

    const showBrowserNotification = (title, body, onClick) => {
        if (!('Notification' in window)) return;

        if (Notification.permission === 'granted') {
            try {
                const n = new Notification(title, { body });

                if (onClick) {
                    n.onclick = (event) => {
                        event.preventDefault();
                        onClick();
                        n.close();
                    };
                }
            } catch (err) {
                // System notification failed
            }
        } else {
            // No system notification permission
        }
    };

    /**
     * 统一通知接口
     * @param {Object} options
     * @param {string} options.title - 通知标题
     * @param {string} options.descÏription - 通知内容
     * @param {Function} [options.onAcknowledge] - 用户点击确认按钮后触发
     */
    const notify = ({ title, description, onAcknowledge }) => {
        const key = `notification_${Date.now()}`;

        const acknowledgeBtn = (
            <Button type="primary" size="small" onClick={async () => {
                try {
                    if (onAcknowledge) {
                        await onAcknowledge();
                        // 用户已读, 刷新通知数量红点
                        getMessageCount();
                    }
                    notification.close(key); // 手动关掉通知
                } catch (error) {
                    // Acknowledge failed
                }
            }}>
                Acknowledge
            </Button>
        );

        notification.warning({
            message: title,
            description,
            key,
            btn: acknowledgeBtn,
            onClick: () => {
                notification.close(key);
            },
        });

        showBrowserNotification(title, description, onAcknowledge);
        // 有新通知, 刷新通知数量红点
        getMessageCount();
    };

    return { notify };
};
